<template>
  <div>
    <v-btn icon target="_blank" :href="gameLink(item)">
      <v-icon color="green lighten-2">fa-gamepad</v-icon>
    </v-btn>
  </div>
</template>

<script>
  export default {
    props: ["item"],
    methods: {
      gameLink(item) {
        if (item.target) {
          var name = item.name
          var type = name.match(/^[A-za-z]{1,2}[0-9]/)[0].replace(/[0-9]$/,"").toLowerCase()
          var url = ""

          if (type == 'tt')
            url = process.env.VUE_APP_TARGETTIME_URL + '/game/' + item.id;
          else
            url = process.env.VUE_APP_JUMBLEWORD_URL + '/game/' + item.id;

          return url;

        } else {
          return process.env.VUE_APP_ALFAKODO4_URL + '/game/' + item.id
        }
      },
    }
  }
</script>
